"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoRooms/History/Modal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);




var _videoRoom = require('web/selectors/videoRoom');
var _hooks = require('web/services/hooks');
var _helpers = require('web/components/VideoRooms/Room/History/helpers');

var _Modal = require('web/components/VideoRooms/Room/History/Desktop/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Modal3 = require('web/components/VideoRooms/Room/History/Mobile/Modal'); var _Modal4 = _interopRequireDefault(_Modal3);

const modalScreens = {
  HISTORY: 'MODAL_SCREEN_HISTORY',
  DETAILS: 'MODAL_SCREEN_DETAILS',
} 














// SAFETY: the action sends the list request and resolves the server's
// VideoRoomSessionList response (or undefined when the send fails and is
// logged), which is the shape the history lists read.
const loadSessionsList = _actions2.default.loadVideoRoomSessionsList 

// memo keeps connect()'s bailout on unchanged own props.
const HistoryModal = _react.memo.call(void 0, function HistoryModal ({
  isMobile, onClose,
}) {
  const roomKey = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomKey)
  const roomName = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomName)

  const [state, setState] = _helpers.useClassState(() => ({
    currentScreen: modalScreens.HISTORY,
    currentSessionKey: null,
  }))
  const { currentScreen, currentSessionKey } = state

  const gotoHistory = _react.useCallback.call(void 0, 
    () => setState({ currentScreen: modalScreens.HISTORY }), [setState])
  const gotoDetails = _react.useCallback.call(void 0, 
    () => setState({ currentScreen: modalScreens.DETAILS }), [setState])

  // As in the class: the details screen opens after the picked key commits.
  const handleSessionPick = _react.useCallback.call(void 0, (sessionKey) =>
    setState({ currentSessionKey: sessionKey }, gotoDetails), [setState, gotoDetails])

  const Modal = isMobile ? _Modal4.default : _Modal2.default

  // The JS also passed gotoDetails, which neither modal reads; the details
  // screen is only reached through onSessionPick, after a key is set.
  return (
    _react2.default.createElement(Modal, {
      isOpen: true,
      onClose: onClose,
      roomKey: roomKey,
      roomName: roomName,
      loadSessionsList: loadSessionsList,
      onSessionPick: handleSessionPick,
      isOnHistoryScreen: currentScreen === modalScreens.HISTORY,
      gotoHistory: gotoHistory,
      currentSessionKey: currentSessionKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
    )
  )
})

exports. default = HistoryModal
